<template>
  <div>
    FOOTER
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>